import { Injectable } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { ActiveRegionService } from '../../../../../blocks/service/active-region.service';
import { MonModalService } from 'app/modules/modals/services/mon-modal/mon-modal.service';
import { PdfService } from '../../../../../services/entities/pdf/pdf.service';

@Injectable({
    providedIn: 'root',
})
export class AccPdfAccessibilityRemediationService {
    private isInEuRegion: boolean;

    constructor (
        private pdfService: PdfService,
        private translateService: TranslateService,
        private monEventService: MonEventService,
        private activeRegionService: ActiveRegionService,
        private monModalService: MonModalService,
    ) {
        this.isInEuRegion = this.activeRegionService.isInRegion('EU');
    }

    createRemediation (pdf: any): Promise<any> {
        return this.pdfService.createRemediation(pdf).then(() => {
            this.monEventService.run('remediationCreated', { url: pdf.url, title: pdf.title });
        }, () => {});
    }

    createRemediationDialog (cb?: () => void): void {
        const options = {
            message: this.getConfirmationMessage(),
            title: '',
            buttons: [
                {
                    label: this.isInEuRegion ? this.translateService.getString('Close') : this.translateService.getString('Cancel'),
                    className: 'btn btn-secondary',
                    callback: () => {},
                },
            ],
        };

        if (!this.isInEuRegion) {
            options.buttons.push({
                label: this.translateService.getString('Submit'),
                className: 'btn btn-primary',
                callback: cb || (() => {}),
            });
        }

        this.monModalService.customDialog(options, {}).then(() => {}, () => {});
    }

    private getConfirmationMessage (): string {
        if (!this.isInEuRegion) {
            return this.translateService.getString(
                'Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc.' +
                'For remediation, we will coordinate with NetCentric to review the document and provide you a fixed price for the remediation. ' +
                'Upon completion of the work, NetCentric will also provide a compliance report. ' +
                'NetCentric will let you know if there is any Alternative Text (Alt-Text) required for images that are not self-descriptive or any related additional information needed to remediate the document. ' +
                'Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric\'s Terms and Conditions and Privacy Policy.',
            );
        }

        return this.translateService.getString(
            'Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc. ' +
            'Due to the regulatory framework requirements in your country, we are not able to coordinate document remediation directly for you; ' +
            'however, you are invited to reach out to NetCentric directly for a quote and remediation services at dherr@allyant.com. ' +
            'Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric\'s Terms and Conditions and Privacy Policy ' +
            'and will result in a transfer of data to third parties and third countries, including but not limited to the United States, Canada, Australia, and Egypt.',
        );
    }
}
